import React from 'react';
import styled from 'styled-components';
import DropdownMenu from './DropdownMenu';
import SearchBar from './SearchBar';
import Button from '@mui/material/Button';
import { xs } from '../BreakPoints';
import ProfileBox from './ProfileBox';
import { useHistory } from 'react-router-dom';
import infrasa from "../Images/infrasa-logo.png";
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from 'react-redux';

const Container = styled.div`
	height: 3rem;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	backdrop-filter: blur(24px);
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 0.5rem 1rem;
	gap: 0.5rem;
	${xs({
		padding: '0.5rem, 0rem',
	})}
`;

const LeftSide = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	gap: 1rem;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	${xs({
		gap: '0.1rem',
		width: 'fit-content',
	})}
`;

const RightSide = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
`;

const LogoContainer = styled.div`
	display: flex;
	align-items: center;
`;

const TrelloLogo = styled.img`
	width: 75px;
	height: 15px;
	cursor: pointer;
`;

const DropdownContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	${xs({
		display: 'none',
	})}
`;

const BootstrapButton = styled(Button)({
	boxShadow: 'none',
	textTransform: 'none',
	gap: '0.25rem',
	padding: '0.25rem 0.5rem',
	color: 'white',
	backgroundColor: 'transparent',
	border: 'none',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-around',

	'&:hover': {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
	},
	'&:active': {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
	},
});

const Navbar = (props) => {
	const history = useHistory();

	

	return (
		<Container>
			<LeftSide>
				<LogoContainer>
					{/* <TrelloLogo
						onClick={() => {
							history.push('/boards');
						}}
						src='https://a.trellocdn.com/prgb/dist/images/header-logo-spirit-loading.87e1af770a49ce8e84e3.gif'
					/> */}
					<TrelloLogo
						onClick={() => {
							history.push('/boards');
						}}
						src={infrasa}
					/>
				</LogoContainer>
				<DropdownContainer>
					<DropdownMenu title='Meus quadros' />
				</DropdownContainer>
				<BootstrapButton onClick={()=>history.push("/boards")}>Quadros</BootstrapButton>
				<BootstrapButton onClick={()=>history.push("/dashboard")}>Dashboard</BootstrapButton>
			</LeftSide>
			<RightSide>
				{/* <SearchBar searchString={props.searchString} setSearchString={props.setSearchString} /> */}
				<ProfileBox />
			</RightSide>
		</Container>
	);
};

export default Navbar;
